import { render, staticRenderFns } from "./KaIDField.vue?vue&type=template&id=1429de44"
import script from "./KaIDField.vue?vue&type=script&lang=ts"
export * from "./KaIDField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports